export enum ToolStatus {
  Inactive = 'Inactive',
  Active = 'Active',
  Future = 'Future',
  Deprecated = 'Deprecated',
  NotAllowed = 'NotAllowed',
  Draft = 'Draft',
}
